import ReactDOM from "react-dom/client";
// import reportWebVitals from "@test/reportWebVitals";
import AppProviders from "./AppProviders";
import { ignoreLogs } from "@lib/helpers/Common";
import { registerSW } from "virtual:pwa-register";

ignoreLogs([
  "findDOMNode is deprecated and will be removed in the next major release.",
  "cannot appear as a descendant of",
  "Function components cannot be given refs. Attempts to access this ref will fail.",
  "If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase",
  "If you want to write it to the DOM, pass a string instead",
]);

ReactDOM.createRoot(document.getElementById("root")!).render(<AppProviders />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

const intervalMS = 60 * 60 * 1000;

registerSW({
  immediate: true,
  onRegistered(r) {
    if (r) {
      setInterval(() => {
        r.update();
      }, intervalMS);
    }
  },
});
